import React from 'react'
import './index.css'
import { CssBaseline, Container, useTheme, ThemeProvider } from '@mui/material'
import {
  Route,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom/cjs/react-router-dom.min'
import Menu from './components/Menu'
import Home from './pages/Home'
import styled from '@emotion/styled'
import ReturnTop from './components/ReturnTop'
import theme from './theme'

import imgBg from './assets/純背景.png'
import Footer from './components/Footer'

const Page = styled.div`
  background-image: url(${imgBg});
  background-position: left top;
  background-size: cover;
  width: 100%;
`

export default function App() {
  return (
    <ThemeProvider theme={theme} >
      <Page>
      <Router>
        <CssBaseline />
        {/* <img src={imgBg} style={{ width: '100vw', zIndex: -9, position:'relative' }} alt=''/> */}
        <Menu />
        <div>
          {/* SPA 頁面 */}
          <Switch>
            <Route exact path="/" render={() => <Home />}></Route>
          </Switch>
          {/* 回到頂部 btn */}
          <ReturnTop />
          <Footer />
        </div>
      </Router>
    </Page>
    </ThemeProvider>
    
  )
}
